import { Link } from "react-router-dom";

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

const Breadcrumb = ({ items, className = "" }: BreadcrumbProps) => {
  return (
    <nav
      aria-label="Breadcrumb"
      className={`flex items-center flex-wrap gap-1.5 text-xs ${className}`}
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <span className="w-3 h-3 flex items-center justify-center opacity-40">
                <i className="ri-arrow-right-s-line text-xs"></i>
              </span>
            )}
            {isLast || !item.href ? (
              <span className={`font-medium truncate max-w-[180px] ${isLast ? "text-stone-700" : "text-stone-400"}`}>
                {item.label}
              </span>
            ) : (
              <Link
                to={item.href}
                className="text-stone-400 hover:text-amber-600 transition-colors truncate max-w-[180px] whitespace-nowrap"
              >
                {item.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
